// extracted by mini-css-extract-plugin
export default {"hiddenTab":"Tab_hiddenTab__KOLRZ"};